// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-title[data-v-614ffe70]{font-size:85%!important}.v-icon[data-v-614ffe70]{color:#2b313d;margin:0 auto}a[data-v-614ffe70]{font-weight:400!important}a[data-v-614ffe70]:hover{background:#f6f6f6!important;text-decoration:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
